import { edit } from 'ui/Icons';
import { CircleIconButton } from "ui/CircleIconButton";
import React from 'react';

interface IExternalLinkProps {
  link: string;
  label: string;
  onClick: () => void;
}

export const ExternalLink: React.FC<IExternalLinkProps> = ({ link, label, onClick }) => {
  return (
    <span className="assign-to-me font-pt-sans text-[13px] leading-[17px] underline text-brown-100 cursor-pointer top-0 right-[2px] w-fit flex items-center gap-[10px]">
      <span
        onClick={() => {
          window.open(link, '_blank');
        }}
      >
        {label}
      </span>
      <CircleIconButton
        type="secondary"
        className="edit-action mx-1"
        iconClass="inline relative left-0 top-1px w-12px h-12px"
        iconSrc={edit}
        onClick={onClick}
      />
    </span>
  );
};
